<template>
  <div class="the-navbar__user-meta flex items-center">

    <vs-select class="ml-4" v-model="localUser.tenant" @change="changeTenant">>
      <vs-select-item :key="tenant.code" :value="tenant.code" :text="tenant.name" v-for="tenant in tenants" />
    </vs-select>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    user: {
      name: "",
      tenant: ""
    },
  },

  data() {
    return {
      tenants: [],
      localUser: {
        name: "",
        tenant: ""
      },
    }
  },
  beforeMount() {
    this.loadTenants()
  },
  created() {
    this.copyUser()
  },
  methods: {
    loadTenants() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/tenant/`)
        .then((response) => {
          this.tenants = response.data
        })
    },
    copyUser() {
      this.localUser.name = this.user.name
      this.localUser.lastName = this.user.lastName
      this.localUser.email = this.user.email
      this.localUser.tenant = this.user.tenant
    },

    changeTenant() {
       axios.put(`${process.env.VUE_APP_API}/api/v1/users/change-tenant/`, this.localUser)
        .then((response) => {
          let responseUser = response.data
          this.$emit('update:tenant', responseUser.tenant)
          this.$emit('update:tenantType', responseUser.tenantType)
          this.user.tenant = responseUser.tenant
          this.user.tenantType = responseUser.tenantType
          localStorage.currentUser = JSON.stringify(this.user)
          location.reload()
        })
    }

  }
}
</script>
